import { render, staticRenderFns } from "./addNewAsset.vue?vue&type=template&id=98443a42&scoped=true&"
import script from "./addNewAsset.vue?vue&type=script&lang=js&"
export * from "./addNewAsset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98443a42",
  null
  
)

export default component.exports